import React, { useState, useEffect } from 'react'
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { Formik, Field, Form } from 'formik';
import { toast } from "react-toastify";
import * as Yup from 'yup';
import { useNavigate } from 'react-router';
import FormikErrorFocus from "formik-error-focus";
import { SlDrawer, SlInput, SlIcon } from '@shoelace-style/shoelace/dist/react';
import { useFormik } from "formik";
import api from "../../services/api";
import { formatDateWithTime } from '../../utils/dateFormat';
import NoDataFound from '../../shared/NoDataFound';
import { Toast } from '../../shared/Toast';
import Paginator from '../../shared/Paginator';
import config from '../../config';
import TableLoader from '../../shared/TableLoader';
import { useDispatch, useSelector } from 'react-redux';
import { ScrollContainer } from 'react-indiana-drag-scroll';
import Select from "react-select"
import { debounce } from '../../utils/Debounce';
import { SlTooltip, SlIconButton, SlButton } from '@shoelace-style/shoelace/dist/react';
import PendingRequestModal from '../MakerChecker/components/PendingRequestModal';

const userRole_Options = [
    {value:1, label:"Maker"},
    {value:2, label:"Checker"},
    {value:3, label:"Maker & Checker"},
]
const initialB2b = {
    name: '',
    email: '',
    mobile: '',
    password: '',
    newspaperData: false,
    b2bData: false,
    agencyData: false,
    competitorData: false,
    requests: false,
    newspapers:false
}

let initialValues = JSON.parse(JSON.stringify(initialB2b));

const B2bSchema = Yup.object().shape({
    name: Yup.string().matches(/^[a-zA-Z][a-zA-Z\s]*$/, "Name can't start with white space and should not contain special characters").required('Name is required'),
    email: Yup.string().email().required('Email is required'),
    mobile: Yup.string()
        .matches(/^[6-9]\d{9}$/, "Invalid Mobile number")
        .min(10, "Mobile must be 10 digits")
        .max(10, "Mobile must be 10 digits")
        .required("Mobile Number is required"),
    password: Yup.string().matches(/^[a-zA-Z0-9.\/!@#$%^&*+~?-]+$/, "Password should not contain any white space").required("Password is required"),
    newspaperData: Yup.boolean().optional().default(false),
    b2bData: Yup.boolean().optional().default(false),
    competitorData: Yup.boolean().optional().default(false),
    agencyData: Yup.boolean().optional().default(false),
    requests: Yup.boolean().optional().default(false),
    brands:Yup.boolean().optional().default(false),
    newspapers:Yup.boolean().optional().default(false),
    planning:Yup.boolean().optional().default(),
    buildup:Yup.boolean().optional().default(false),
    reports:Yup.boolean().optional().default(false),
})


function B2B() {

    const navigate = useNavigate();

    const [delId, setDelId] = useState(-1);
    const [delname, setDelname] = useState("")
    const [del, setDel] = useState(false);
    const [data, setData] = useState([]);
    const [show, setShow] = useState(false);
    const [loader, setLoader] = useState(false);
    const [submit, setSubmit] = useState(false);
    const [flag, setFlag] = useState('')
    const [id, setId] = useState('');
    const [search, setSearch] = useState("")
    
    const [totalPages, setTotalPages] = useState(0);
    const [currentPage, setCurrentPage] = useState(0);
    const [otp, setOtp] = useState({});
    const [editingRoles, setEditingRoles] = useState({});
    const [userRoles,setUserRoles]=useState({})
    const [tempRoles,setTempRoles]=useState({});

    const [selectedMcId,setSelectedMcId] = useState('');
    const handleCloseModal = () => {
        setSelectedMcId(null);
    };
    const handlePageClick = (event) => {
        setCurrentPage(event.selected);
        loadData(search, event.selected);
        setOtp({});
    };

    const HeaderSearch = useSelector(state => state.Head.adssearch);

    const handleClose = () => {
        setShow(false);
        setSubmit(false);
        initialValues = JSON.parse(JSON.stringify(initialB2b));
        formik.setValues(initialValues);
    };

    const handleShow = (choose, item) => {
        if (choose === "add") {
            formik.setValues(item);
            setShow(true);
        }
        if (choose === 'edit') {
            initialValues.email = item.email
            initialValues.name = item.name
            initialValues.mobile = item.mobile
            initialValues.password = item.password
            initialValues.newspaperData = item.permissions[0].newspaperData
            initialValues.b2bData = item.permissions[0].b2bData
            initialValues.competitorData = item.permissions[0].competitorData
            initialValues.agencyData = item.permissions[0].agencyData
            initialValues.requests = item.permissions[0].requests
            initialValues.brands = item.permissions[0].brands
            initialValues.newspapers = item.permissions[0].newspapers
            initialValues.planning = item.permissions[0].planning
            initialValues.buildup = item.permissions[0].buildup
            initialValues.reports = item.permissions[0].reports
            initialValues.status = item.status
            formik.setValues(initialValues);
            setShow(true)
        }
    };

    useEffect(() => {
        Header()
    }, [HeaderSearch]);

    const deleteB2B = async (id1) => {
        try {
            await api({
                url: `/user/b2b_team/${id1}`,
                method: "DELETE",
                responseType: "json"
            });
            toast.success("B2b Person Deleted Successfully");
            setCurrentPage(0);
            setSearch('');
            loadData(search, 0);
        } catch (error) {
            let er = error?.response?.message || "Something went wrong"
            Toast("error", er)
            if (error.response.status === 401)
                navigate("/")
        }
    }

    const loadData = async (searchString = '', page = 0) => {
        try {
            setLoader(true);
            let res = await api({
                url: `/user/b2b_team/getB2bteam`,
                method: "POST",
                responseType: "json",
                data: {
                    page,
                    limit: config.PER_PAGE,
                    search: searchString
                }
            });
            setData(res.data.data.length ? res.data.data : [])
            const TempRoles = {};
            (res.data.data || []).forEach(user => {
                const mc_Role = userRole_Options.find(role=>role.value===user.mc_role);
                if(mc_Role) TempRoles[user.b2b_id] = mc_Role;
            });
            setTempRoles(TempRoles);
            setUserRoles(TempRoles);
            setTotalPages(Math.ceil(res.data.total / config.PER_PAGE));
            setLoader(false);
        } catch (error) {
            setLoader(false);
            if (error.response.status === 401)
                navigate("/")
        }
    }

    const Header = () => {
        setSearch(HeaderSearch);
        setCurrentPage(0);
        loadData(HeaderSearch, 0);
    };

    const searchData = e => {
        setSearch(e.target.value);
        setCurrentPage(0);
        loadData(e.target.value, 0);
        setOtp({});
    }
    function handleRequestClose(event) {
        if (event.detail.source === 'overlay') {
            event.preventDefault();
        }
    }
    const handledelClose = () => {
        setDel(false)
    };

    const startEditing = (b2b_id) => {
        setEditingRoles(prev => ({ ...prev, [b2b_id]: true }));
        setTempRoles(prev => ({ ...prev, [b2b_id]: userRoles[b2b_id] }));
    };

    const cancelEditing = (b2b_id) => {
        setEditingRoles(prev => ({ ...prev, [b2b_id]: false }));
        setTempRoles(prev => ({ ...prev, [b2b_id]: userRoles[b2b_id] }));
    };

  const saveRole = async (b2b_id) => {
        setUserRoles(prev => ({ ...prev, [b2b_id]: tempRoles[b2b_id] }));
        setEditingRoles(prev => ({ ...prev, [b2b_id]: false }));
        let res = await api({
            url: `/user/b2b_team/user_role`,
            method: "POST",
            responseType: "json",
            data: {
                b2b_id,
                mc_role:tempRoles[b2b_id]?.value
            },
        });
        if (res?.status==="SUCCESS") {
            Toast('success', res.message);
            loadData(search,currentPage);
        }else{
            Toast("error","Failed To Change User Role");
        }
  };

  const handleChange = (b2b_id, selectedOption) => {
    setTempRoles(prev => ({ ...prev, [b2b_id]: selectedOption }));
  };

    let formik = useFormik({
        initialValues: JSON.parse(JSON.stringify(initialB2b)),
        validationSchema: B2bSchema,
        onSubmit: async (values) => {
            if (flag === 'add') {
                try {
                    let res = await api({
                        url: `/user/b2b_team/${id}`,
                        method: "POST",
                        responseType: "json",
                        data: {...values,ref_table:'b2b'}
                    });
                    if (res?.data?.code === 500) {
                        Toast('error', res.data.message);
                    } else {
                        Toast("success", res.message);
                        handleClose();
                        setCurrentPage(0);
                        setSearch('');
                        loadData(search, 0);
                        setOtp({});
                    }
                } catch (error) {
                    let er = error?.response?.message || "Something went wrong"
                    Toast("error", er)
                    if (error.response.status === 401)
                        navigate("/")
                }
            }
            if (flag === 'edit') {
                try {
                    const result = await api({
                        url: `/user/b2b_team/${id}`,
                        method: "PUT",
                        responseType: "json",
                        data: {...values,ref_table:"b2b"}
                    });
                    if(result.status==='SUCCESS'){
                        Toast("success", "B2B updated Successfully");
                        handleClose()
                        loadData(search, currentPage);
                        setOtp({});
                        values.name = ''
                        values.email = ''
                        values.mobile = ''
                        values.password = ''
                    }else{
                        Toast('error',result.data?.message || 'Something went wrong')
                    }
                } catch (error) {
                    let er = error?.response?.message || "Something went wrong"
                    Toast("error", er)
                    if (error.response.status === 401)
                        navigate("/")
                }
            }
        }
    });

    const viewOTP = async (mobile, userType, index) => {
        try {
            let res = await api({
                url: `/user/sales_persons/viewOTP`,
                method: "POST",
                responseType: "json",
                data: {
                    mobileno: mobile,
                    type: userType,
                },
            });
            if (res?.code === 200) {
                const updatedOtpData = { ...otp };
                updatedOtpData[index] = res?.data?.length ? res?.data[0].otp : "OTP not found"
                setOtp(updatedOtpData);
                // Toast("success", "OTP displayed Successfully");
            } else {
                Toast("error", res.data.message);
                const updatedOtpData = { ...otp };
                updatedOtpData[index] = '';
                setOtp(updatedOtpData);
            }
        } catch (error) {
            let er = error?.response?.message || "Something went wrong";
            Toast("error", er);
            setOtp({})
            if (error.response.status === 401) navigate("/");
        }

    }


    return (
        <>
            <SlDrawer label="Are you sure!" open={del} onSlRequestClose={handleRequestClose} onSlAfterHide={handledelClose}>
                <p>The B2B Person <span style={{ fontFamily: "Arial", fontWeight: "bold" }}>{delname}</span> will be deleted</p>
                <div className='d-flex gap-2'>
                    <Button variant="success" onClick={() => setDel(false)}>
                        Cancel
                    </Button>
                    <Button variant="danger" onClick={() => { setDel(false); deleteB2B(delId) }}>Confirm</Button>
                </div>
            </SlDrawer>
            <div className='flex gap-4 justify-end mb-4'>
                <SlInput size="small" id="myInput" onSlInput={debounce(searchData, 500)} placeholder="Search By Name / Email / Mobile" >
                    <SlIcon library="lucide" name="search" slot="prefix"></SlIcon>
                </SlInput>
                <SlButton size="small" variant="primary" onClick={() => { handleShow("add", {}); setFlag('add') }}>Add B2B</SlButton>
            </div>
            <SlDrawer label="Create B2B Person" open={show} onSlRequestClose={handleRequestClose} onSlAfterHide={handleClose} >
                <form onSubmit={formik.handleSubmit}>
                    <div className="mb-3">
                        <label className="mb-1"> Name</label><span className="text-red-600">*</span>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Enter B2B Person Name"
                            aria-label=""
                            name="name"
                            value={formik.values.name}
                            onBlur={formik.handleBlur}
                            onChange={(e) => {
                                formik.handleChange(e);
                            }}
                        />
                        {submit && formik.errors.name ? (
                            <div className="text-red-600	">{formik.errors.name}</div>
                        ) : null}
                    </div>
                    <div className="mb-3" >
                        <label className="mb-1">Email</label><span className="text-red-600">*</span>
                        <input
                            type='email'
                            className="form-control"
                            placeholder='Enter Email'
                            name='email'
                            aria-label=""
                            value={formik.values.email}
                            onBlur={formik.handleBlur}
                            onChange={(e) => {
                                formik.handleChange(e);
                            }}
                        />
                        {submit && formik.errors.email ? (
                            <div className="text-red-600	">{formik.errors.email}</div>
                        ) : null}
                    </div>
                    <div className="mb-3" >
                        <label className="mb-1"> Mobile No</label><span className="text-red-600">*</span>
                        <input
                            className="form-control"
                            type='tel'
                            name='mobile'
                            placeholder='Enter Mobile No'
                            aria-label=""
                            value={formik.values.mobile}
                            onBlur={formik.handleBlur}
                            onChange={(e) => {
                                formik.handleChange(e);
                            }}
                        />
                        {submit && formik.errors.mobile ? (
                            <div className="text-red-600	">{formik.errors.mobile}</div>
                        ) : null}
                    </div>
                    <div className="mb-3" >
                        <label className="mb-1"> Password</label><span className="text-red-600">*</span>
                        <input
                            className="form-control"
                            type='text'
                            name='password'
                            placeholder='Enter Password'
                            aria-label=""
                            value={formik.values.password}
                            onBlur={formik.handleBlur}
                            onChange={(e) => {
                                formik.handleChange(e);
                            }}
                        />
                        {submit && formik.errors.password ? (
                            <div className="text-red-600	">{formik.errors.password}</div>
                        ) : null}

                    </div>

                    <div className="mb-3">
                        <label className="mb-1">Permissions</label><span className="text-red-600">*</span>
                        <div>
                            <label>
                                <input
                                    type="checkbox"
                                    name="newspaperData"
                                    checked={formik.values.newspaperData}
                                    onChange={(e) => {
                                        formik.setFieldValue('newspaperData', e.target.checked);
                                    }}
                                />
                                National
                                {submit && formik.errors.newspaperData ? (
                                    <div className="text-red-600	">{formik.errors.newspaperData}</div>
                                ) : null}
                            </label>
                        </div>
                        <div>
                            <label>
                                <input
                                    type="checkbox"
                                    name="agencyData"
                                    checked={formik.values.agencyData}
                                    onChange={(e) => {
                                        formik.setFieldValue('agencyData', e.target.checked);
                                    }}
                                />
                                Agency Data
                                {submit && formik.errors.agencyData ? (
                                    <div className="text-red-600	">{formik.errors.agencyData}</div>
                                ) : null}
                            </label>
                        </div>
                        <div>
                            <label>
                                <input
                                    type="checkbox"
                                    name="b2bData"
                                    checked={formik.values.b2bData}
                                    onChange={(e) => {
                                        formik.setFieldValue('b2bData', e.target.checked);
                                    }}
                                />
                                B2B Data
                                {submit && formik.errors.b2bData ? (
                                    <div className="text-red-600	">{formik.errors.b2bData}</div>
                                ) : null}
                            </label>
                        </div>
                        <div>
                            <label>
                                <input
                                    type="checkbox"
                                    name="competitorData"
                                    checked={formik.values.competitorData}
                                    onChange={(e) => {
                                        formik.setFieldValue('competitorData', e.target.checked);
                                    }}
                                />
                                Competitor Data
                                {submit && formik.errors.competitorData ? (
                                    <div className="text-red-600	">{formik.errors.competitorData}</div>
                                ) : null}
                            </label>
                        </div>
                        <div>
                            <label>
                                <input
                                    type="checkbox"
                                    name="requests"
                                    checked={formik.values.requests}
                                    onChange={(e) => {
                                        formik.setFieldValue('requests', e.target.checked);
                                    }}
                                />
                                Requests
                                {submit && formik.errors.requests ? (
                                    <div className="text-red-600	">{formik.errors.requests}</div>
                                ) : null}
                            </label>
                        </div>
                        <div>
                            <label>
                                <input
                                    type="checkbox"
                                    name="requests"
                                    checked={formik.values.brands}
                                    onChange={(e) => {
                                        formik.setFieldValue('brands', e.target.checked);
                                    }}
                                />
                                Brands
                                {submit && formik.errors.brands ? (
                                    <div className="text-red-600	">{formik.errors.brands}</div>
                                ) : null}
                            </label>
                        </div>
                        <div>
                            <label>
                                <input
                                    type="checkbox"
                                    name="requests"
                                    checked={formik.values.newspapers}
                                    onChange={(e) => {
                                        formik.setFieldValue('newspapers', e.target.checked);
                                    }}
                                />
                                NewsPapers
                                {submit && formik.errors.newspapers ? (
                                    <div className="text-red-600	">{formik.errors.brands}</div>
                                ) : null}
                            </label>
                        </div>
                        <div>
                            <label>
                                <input
                                    type="checkbox"
                                    name="requests"
                                    checked={formik.values.planning}
                                    onChange={(e) => {
                                        formik.setFieldValue('planning', e.target.checked);
                                    }}
                                />
                                Planning Tab
                                {submit && formik.errors.planning ? (
                                    <div className="text-red-600	">{formik.errors.planning}</div>
                                ) : null}
                            </label>
                        </div>
                        <div>
                            <label>
                                <input
                                    type="checkbox"
                                    name="requests"
                                    checked={formik.values.buildup}
                                    onChange={(e) => {
                                        formik.setFieldValue('buildup', e.target.checked);
                                    }}
                                />
                                Buildup
                                {submit && formik.errors.buildup ? (
                                    <div className="text-red-600	">{formik.errors.buildup}</div>
                                ) : null}
                            </label>
                        </div>
                        <div>
                            <label>
                                <input
                                    type="checkbox"
                                    name="requests"
                                    checked={formik.values.reports}
                                    onChange={(e) => {
                                        formik.setFieldValue('reports', e.target.checked);
                                    }}
                                />
                                Brand Reports
                                {submit && formik.errors.reports ? (
                                    <div className="text-red-600	">{formik.errors.reports}</div>
                                ) : null}
                            </label>
                        </div>
                    </div>

                    {flag === "edit" && (
                        <div className="mb-3 form-check form-switch">
                            <label className="form-check-label">
                                Status ({formik.values.status ? "Active" : "Inactive"})
                            </label>
                            <input
                                className="form-check-input"
                                type="checkbox"
                                role="switch"
                                checked={formik.values.status}
                                onChange={() => {
                                    formik.setFieldValue("status", formik.values.status ? 0 : 1);
                                }}
                            />
                        </div>
                    )}

                    <div slot="footer">
                        <SlButton
                            type="submit"
                            variant="primary"
                            size="small"
                            onClick={(e) => setSubmit(true)}>Submit</SlButton>
                    </div>

                </form>
            </SlDrawer>
            < div className=' mb-4' >
                <ScrollContainer>
                <table className='table table-bordered'>
                    <thead className="sticky top-0 ">
                        <tr>
                            <th >Name</th>
                            <th >Email</th>
                            <th >Mobile</th>
                            <th >Password</th>
                            <th>Status</th>
                            <th>Created Date</th>
                            <th>Created By</th>
                            <th>View OTP</th>
                            <th>Actions</th>
                            <th>User Role</th>
                        </tr>
                    </thead>
                    {(data?.length && !loader) ? (
                        <tbody>
                            {data.map((item, index) => {
                                return (
                                    <tr key={item.b2b_id} className="group/details hover:bg-slate-100">
                                        <th scope="row" className="flex items-center justify-center text-center gap-2">
                                            {item?.mc_actions?.length ?<button className="h-2 w-2 px-1 py-1 rounded-full bg-orange-300" title={`pending edit action by ${item?.mc_actions?.[0]?.mc_user_name}`} onClick={() => setSelectedMcId(item?.mc_actions?.[0]?.mc_id)}></button>: null}
                                            <span>{item.name}</span>
                                        </th>
                                        <td >{item.email}</td>
                                        <td >{item.mobile}</td>
                                        <td >{item.password}</td>
                                        <td>
                                            <span className={item.status === 0 ? "unpaid-badge text-center" : item.status > 0 ? "full-badge text-center" : "pending-badge text-center"}>
                                                {item.status === 0 ? "Inactive" : item.status > 0 ? "Active" : "-"}
                                            </span>
                                        </td>
                                        <td >{formatDateWithTime(item.created_date)}</td>
                                        <td >{item.user_name || '-'}</td>
                                        <td>
                                            {otp[index] ? (
                                                <span>{otp[index]}</span>
                                            ) : (
                                                <SlTooltip content="View OTP">
                                                    <SlIconButton
                                                        library="lucide"
                                                        name="eye"
                                                        onClick={() => viewOTP(item.mobile, "b2b", index)}
                                                    ></SlIconButton>
                                                </SlTooltip>
                                            )}
                                        </td>
                                        <td >
                                            <div className='inline-flex gap-3'>
                                                <SlTooltip content="Edit B2B">
                                                    <SlIconButton
                                                        library="lucide"
                                                        name="edit"
                                                        onClick={() => { handleShow("edit", item); setFlag('edit'); setId(item.b2b_id) }}></SlIconButton>
                                                </SlTooltip>
                                                <form action="" method="POST">
                                                    {/* <SlTooltip content="Delete B2B">
                                                        <SlIconButton
                                                            library="lucide"
                                                            name="trash-2"
                                                            onClick={() => { setDel(true); setDelId(item.b2b_id); setDelname(item.name) }}></SlIconButton>
                                                    </SlTooltip> */}
                                                </form>
                                            </div>
                                        </td>
                                        <td>
                                            {editingRoles[item.b2b_id] ? (
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                <Select
                                                    options={userRole_Options}
                                                    value={tempRoles[item.b2b_id]}
                                                    onChange={(selectedOption) => handleChange(item.b2b_id, selectedOption)}
                                                    styles={{
                                                        container: (base) => ({ ...base, minWidth: 150 }),
                                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }) 
                                                    }}
                                                    menuPortalTarget={document.body}
                                                />

                                                <button onClick={()=>saveRole(item.b2b_id)} className='bg-green-400 rounded-lg px-2 py-1 ml-1'>Save</button>
                                                <button onClick={()=>cancelEditing(item.b2b_id)} className='bg-blue-400 rounded-lg px-2 py-1 ml-1'>Cancel</button>
                                                </div>
                                            ) : (
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                <span>{userRoles[item.b2b_id]?.label || 'No Role'}</span>
                                                <SlIconButton library='lucide' name='edit' onClick={()=>startEditing(item.b2b_id)}/>
                                                </div>
                                            )}
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>) : ((!data?.length && !loader)
                            ? <NoDataFound colspan="10" />
                            : <TableLoader colspan="10" />
                    )
                    }
                </table>
                </ScrollContainer>
            </div >
            <div className="flex justify-end"> {totalPages > 1 && <Paginator pageCount={totalPages} handlePageClick={handlePageClick} forcePage={currentPage} />}</div>
            <PendingRequestModal mc_id={selectedMcId} isOpen={!!selectedMcId} onClose={handleCloseModal} />
        </>
    )
}

export default B2B